<app-page>

  <app-page-nav>
    <app-sidebar class="sidebar" role="sidebar"></app-sidebar>
  </app-page-nav>


    <app-no-product
      class="has-no-home"
      [title]="'common-app.__WELCOME' | AsyncLang | async"
      [text]="'common-app.__NO_PRODUCT_NEW_USER' | AsyncLang | async"
      [discover]="'common-app.__NO_PRODUCT__NEW_DISCOVER_HOMECONTROL' | AsyncLang | async"
      [link]="environment.shopUrl + '?utm_source=webapp_home&utm_medium=referral'">
    </app-no-product>
</app-page>